<template>
  <div v-if="!loading || !isConfirming">
    <div class="confirmation-dialog">
      <div class="dialog-overlay" @click="isConfirming ? null : cancel"></div>
        <div class="dialog-content">
          <h3>{{ confirmationObject?.title }}</h3>
          <p v-html="confirmationObject?.message"></p>

      <!-- Only for variants -->
      <div v-if="confirmationObject.type === 'variant-project'" class="variant-options-container">
        <div class="form">
        <label class="form__group" for="variant-checkbox">Créer une variante<input 
          type="checkbox" 
          id="variant-checkbox" 
          class="form__checkbox"
          v-model="formData.create_variant">
        </label>
      </div>
    
      <div class="form__group">
        <label for="version-input">Version :</label>
        <input 
          type="text" 
          id="version-input" 
          class="form__input"
          v-model="formData.new_version"
          placeholder="ex: 1.1.0">
      </div>
    </div>
    
    <!-- !Only for variants! -->
    <div v-if="confirmationObject.type === 'delete-children-criteria'" class="delete-criteria-options-container">
        <div class="form__group">
          <label for="reference-input">Veuillez entrer la référence du critère :</label>
          <input 
            type="text" 
            id="reference-input" 
            class="form__input"
            v-model="formData.referenceValidation"
            />
            <!-- :placeholder="confirmationObject?.flag" -->
        </div>
        <p v-if="referenceValidationError" class="error-message">La référence ne correspond pas</p>
      </div>
        <div class="dialog-actions" :disabled="isConfirming">
          <!-- <button v-if="!hasBlockingError && (confirmationObject.type === 'referential-analyze-status' || confirmationObject.type === 'project-analyze-status')" @click.prevent="confirm">Continuer</button>
          <button v-if="confirmationObject.type !== 'referential-analyze-status' && confirmationObject.type !== 'project-analyze-status' && (!hasBlockingError && confirmationObject.type === 'delete-referential')" @click.prevent="confirm">Confirmer</button> -->

          <button v-if="!hasBlockingError && (this.confirmationObject.type !== 'referential-analyze-status' || this.confirmationObject.type !== 'project-analyze-status' ||this.confirmationObject.type !=='delete-referential')" @click.prevent="confirm">Continuer</button>
          <button v-if="!(this.confirmationObject.type !== 'referential-analyze-status' || this.confirmationObject.type !== 'project-analyze-status'||this.confirmationObject.type !=='delete-referential')" @click.prevent="confirm">Confirmer</button>

          <button v-if="this.confirmationObject.type !== 'project-analyze-status' && this.confirmationObject.type !== 'referential-analyze-status' || this.confirmationObject.type =='delete-referential'" @click.prevent="cancel">Annuler</button>
          <button v-if="this.confirmationObject.type === 'project-analyze-status' || this.confirmationObject.type === 'referential-analyze-status' " @click.prevent="cancel">Retour</button>
        </div>
      </div>
    </div>
  </div>
<LoadingOverlay v-if="loading || isConfirming"/>
</template>
  
  <script>
  import { mapState } from "vuex";
  import LoadingOverlay from "./LoadingOverlay.vue";
  export default {
    name: "ConfirmationDialog",
    data() {
      return {
        formData: {
          create_variant: false,
          new_version: "",
          referenceValidation: "",
        },
        referenceValidationError: false,
        confirmationObject: {
          title: "Confirmation",
          message: "Are you sure you want to proceed?",
          id: null,
        },
        type: null,
        isConfirming: false,
      };
    },
    components:{
      LoadingOverlay
    },
    computed: {
        ...mapState("referential", {referentialConfirmationObject: "confirmationObject",
          referentialLoading : "loading"
        }, "referentialErrors"),
        ...mapState("project", {projectConfirmationObject: "confirmationObject",
          projectLoading : "loading"
        }, "projetErrors"),

        hasBlockingError() {
            return this.confirmationObject?.hasBlockingError || false;
        },
        loading() {
        return this.referentialLoading || this.projectLoading;
        },
    },
    mounted() {
      //console.log("ConfirmationDialog mounted")
      //console.log("confirmationObject 1", this.referentialConfirmationObject)
      //console.log("confirmationObject 2", this.projectConfirmationObject)
      if (this.referentialConfirmationObject && Object.keys(this.referentialConfirmationObject).length > 0) {
        //console.log("Entered referential confirmation")
        this.confirmationObject = this.referentialConfirmationObject
        this.type = "referential"
      } else if (this.projectConfirmationObject && Object.keys(this.projectConfirmationObject).length > 0) {
        //console.log("Entered project confirmation")
        this.type = "project"
        this.confirmationObject = this.projectConfirmationObject
        //console.log("confirmationObject original", this.projectConfirmationObject)
        //console.log("confirmationObject local", this.confirmationObject)
      } else {
        console.error("No confirmation object found")
      }
      document.body.classList.add('modal-open');
    },
    beforeUnmount() {
      document.body.classList.remove('modal-open');
    },
    methods: {
      async confirm() {
        if (this.isConfirming) return;
          this.isConfirming = true;
        if(this.type === "project") {
          this.$store.commit("project/loadingMutation", true)
          //console.log("Confirmed action", this.confirmationObject.id, this.confirmationObject.type)
          try {
            if(this.confirmationObject.type === "delete-project") {
              await this.$store.dispatch("project/projectDelete", { id: this.confirmationObject.id, fromRef: this.confirmationObject.fromRef })
            }else if(this.confirmationObject.type === "project-change-status") {
              //console.log("Changing project status to", this.confirmationObject?.newStatus)
              await this.$store.dispatch("project/projectChangeStatus", { id: this.confirmationObject.id, status: this.confirmationObject?.newStatus, fromRef: this.confirmationObject.fromRef })
              /* if(this.confirmationObject?.newStatus === "ARCHIVE") {
                this.$router.push(`/project`)
              } */
            }
            else if (this.confirmationObject.type === "duplicate-project"){
              //console.log("this.$router :",this.$router, "id :",this.confirmationObject.id)
              await this.$store.dispatch("project/projectDuplicate", { id: this.confirmationObject.id, router: this.$router }, {})
              await this.$store.dispatch("project/fetchProjectList")
            }
            else if (this.confirmationObject.type === "variant-project"){
              await (this.$store.dispatch("project/projectDuplicate", { id: this.confirmationObject.id, router: this.$router, create_variant: this.formData.create_variant, new_version: this.formData.new_version }))
            } else if (this.confirmationObject.type === "project-analyze-status"){
              await this.$store.dispatch("project/projectChangeStatus", { id: this.confirmationObject.id})
            }
          } catch (error) {
            console.error("Error in confirm action", error)
            this.isConfirming = false;

          } finally {
            // //console.log("closing confirmation dialog")
            this.$store.commit("project/toggleConfirmationDialog", false)
            this.$store.commit("project/loadingMutation", false)
          }
        } else if(this.type === "referential") {
          this.$store.commit("referential/loadingMutation", true)
          //console.log("confirmationObject", this.confirmationObject)
          //console.log("Confirmed action", this.confirmationObject.id, this.confirmationObject.type)
          try {
            if(this.confirmationObject.type === "delete-referential") {
              await this.$store.dispatch("referential/referentialDelete", { id: this.confirmationObject.id, hasBlockingError: this.confirmationObject.hasBlockingError })
            }else if(this.confirmationObject.type === "duplicate-referential") {
              await this.$store.dispatch("referential/referentialDuplicate", { id: this.confirmationObject.id, router: this.$router })
            } else if(this.confirmationObject.type === "delete-criteria") {
              await this.$store.dispatch("referential/criteriaDelete", { id: this.confirmationObject.id })
            } else if(this.confirmationObject.type=== "delete-children-criteria"){
              if (this.formData.referenceValidation !== this.confirmationObject.flag) {
                this.referenceValidationError = true;
                return;
              }
              await this.$store.dispatch("referential/criteriaDelete", { id: this.confirmationObject.id })
              this.referenceValidationError = false;
            }else if(this.confirmationObject.type === "delete-question") {
              await this.$store.dispatch("referential/questionDelete", { id: this.confirmationObject.id })
            } else if(this.confirmationObject.type === "referential-change-status") {
              await this.$store.dispatch("referential/referentialChangeStatus", { id: this.confirmationObject.id, status: this.confirmationObject?.newStatus })
              //console.log("changing status to ", this.confifrmationObject?.newStatus)
            } else if (this.confirmationObject.type === "referential-analyze-status"){
              await this.$store.dispatch("referential/referentialChangeStatus", { id: this.confirmationObject.id, status: this.confirmationObject?.newStatus})
            }else if(this.confirmationObject.type === "unlock-referential") {
              await this.$store.dispatch("referential/unlockReferential", { id: this.confirmationObject.id })
            } else if(this.confirmationObject.type === "lock-referential") {
              await this.$store.dispatch("referential/lockReferential", { id: this.confirmationObject.id })
            }
          } catch (error) {
            console.error("Error in confirm action", error)
            this.isConfirming = false;
          } finally {
            // //console.log("closing confirmation dialog")
            this.$store.commit("referential/returnConfirmationCloseMutation", false)
            this.$store.commit("referential/loadingMutation", false)
          }
        }
        /* this.$store.commit("referential/returnConfirmationCloseMutation", false) */
        this.$store.commit("referential/loadingMutation", false)
      },
      cancel() {
        if(this.type === "project") {
          //console.log("Cancelled action")
          this.$store.commit("project/toggleConfirmationDialog", false)
        } else if(this.type === "referential") {
          //console.log("Cancelled action")
          this.$store.commit("referential/returnConfirmationCloseMutation", false)
        }
        this.$emit('close')
      },
    },
  };
  </script>
  
  <style>
  .confirmation-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
  }
  
  .dialog-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    z-index: 1001;
    text-align: center;
    max-height: 90vh; 
    overflow-y: auto; 
    width: 90%;
    max-width: 500px; 
    box-sizing: border-box; 
  }
  
  .dialog-actions {
    margin-top: 20px;
  }
  
  .dialog-actions button {
    margin: 0 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .dialog-actions button:hover {
    background-color: #ccc;
  }
  
.variant-options-container {
  margin: 20px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 20px 5px;
}
.delete-criteria-options-container {
  margin: 20px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 20px 5px;
}

.error-message {
  color: #d32f2f;
  font-weight: bold;
  margin-top: 10px;
}

.form__input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form__input:focus {
  outline: none;
  border-color: var(--primary-color);
}
</style>